import { Component, OnInit, OnDestroy } from '@angular/core';
import { AnnuityItemsViewModel } from '../../../models/annuity-view.model';
import { CSPModifySubscriptionViewModel, GetCSPSubscription, GetCSPSubscriptionActions } from '../../../models/csp.model';
import { ManageService } from '../../../services/manage.service';
import { CommonService } from '../../../services';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { ADKDetailsItemViewModel } from '../../../models/adk-details-view.model';
import { takeUntil } from 'rxjs/operators';

declare var jquery: any;
declare var $: any;
@Component({
  selector: 'app-add-adk-subscription',
  templateUrl: './add-adk-subscription.component.html',
  styleUrls: ['./add-adk-subscription.component.css']
})
export class AddAdkSubscriptionComponent implements OnInit, OnDestroy {

  title: string = 'Add Subscriptions'
  loadContent = false;
  // unsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();
  // params
  programType: string;
  programName: string;
  tenantId: string;

  searchOrder = '';
  newSubscriptionItems: AnnuityItemsViewModel[] = [];
  finishLoading = true;
  newOrderItems: CSPModifySubscriptionViewModel[] = [];
  setDisabled = true;
  sortedSubscriptions: GetCSPSubscription[] = [];

  pendingTotal: number = 0;
  activeTotal: number = 0;
  varianceAmount: number = 0;
  activeItems: GetCSPSubscription[];

  confirmRequired = false;

  adkItems: ADKDetailsItemViewModel;
  subscriptions: GetCSPSubscription[] = [];
  actions: GetCSPSubscriptionActions[];
  invalidTenant = false;


  constructor(
    private manageService: ManageService,
    private commonService: CommonService,
    private activatedRoute: ActivatedRoute,
    private router: Router) { }

  ngOnInit() {
    this.loadContent = false;
    $('#levelOne').animate({ scrollLeft: $('#manageadk').width() + 505 }, 400);
    this.activatedRoute.parent.url.pipe(takeUntil(this.ngUnsubscribe)).subscribe(url => {
      this.manageService.currentProgramType.subscribe(p => this.programType = p);
      this.tenantId = url[1].path;
      this.getSubscriptionOrderList(this.tenantId, this.programType);
    },
      (error: any) => {
        console.info(error);
        this.loadContent = true;
      });
  }

  getSubscriptionOrderList(tenantId, programType): void {
    this.searchOrder = '';
    if (this.newSubscriptionItems.length === 0) {
      this.finishLoading = false;
      this.manageService.getADKItems(tenantId, programType).subscribe((value: AnnuityItemsViewModel[]) => {
        this.newSubscriptionItems = value;
        this.finishLoading = true;

        this.getADKItemsView();
      }, (error: any) => {
        console.info(error);
      });
    }
  }
  
  getADKItemsView() {
    this.manageService.getADKItemsView(this.tenantId, this.programType).subscribe((value: ADKDetailsItemViewModel) => {
      this.adkItems = value;
      if (this.adkItems) {
        this.subscriptions = this.adkItems.subscriptions;
        this.actions = this.adkItems.actions;
        this.sortedSubscriptions = this.adkItems.subscriptions;
        // calculate total amount for each item
        this.sortedSubscriptions.forEach(i => i.out_amount = this.getTotalPrice(i.out_price, i.out_qty));
        //if tenant status is CT or SC or PC- the contract is cancelled so no more operations can be performed for this tenant
        if (this.invalidTenant) {
          this.sortedSubscriptions.forEach(x => x.out_status_desc = 'Cancelled');
        }
        if (this.actions.length) { 
          this.sortedSubscriptions.forEach(x => {
            x.originalQty = x.out_qty;
            x.actions = this.actions.filter(i => i.out_subscription_id === x.out_subscription_id);
            if (x.actions.length) {
              x.actions.forEach(a => {
                switch (a.out_key) {
                  case 'CREATE' : x.pendingChangeText = 'Pending Order Creation'; break;
                  case 'QTY': x.pendingChangeText = 'Pending Qty Change to ' + a.out_value; break;
                  case 'REF': x.pendingChangeText = 'Pending Reference Change to ' + a.out_value; break;
                  case 'REMOVE': x.removeSubscription = true; break;
                }

                if (a.out_status === 'ER') {
                  x.pendingChangeText += ' **Error** - ' + a.out_error_message;
                  x.hasPendingError = true;
                }
              })
            }

            if (x.removeSubscription) {
              x.out_status = 'XX';
              x.pendingChangeText = 'Pending Remove Product';
            }
          });

        }
        this.activeItems = this.subscriptions.filter(x => x.out_status_desc.indexOf('Active') !== -1);
        if (this.activeItems) {
           for (let item of this.activeItems) {
             this.activeTotal = this.activeTotal + parseFloat(item.out_amount);
           }
        }
      }
      
    },
    (error:any) => {
      console.info(error);
    });
  }

  addNewOrders(item: AnnuityItemsViewModel, quantity: string): void {
    let newSubscription = {} as CSPModifySubscriptionViewModel;

    newSubscription.qty = quantity;
    newSubscription.stockCode = item.stockCode;
    newSubscription.stockDescription = item.description;
    newSubscription.tenantId = this.tenantId;
    newSubscription.status = 'Pending Confirm';
    newSubscription.price = item.itemPrice;
    newSubscription.billingFrequency = item.billingFrequencyDesc;
    newSubscription.totalPrice = this.getTotalPrice(item.itemPrice, quantity);

    if (!this.newOrderItems.some((x) => x.stockCode == newSubscription.stockCode)) {
      this.newOrderItems.push(newSubscription);
    } else {
      let index = this.newOrderItems.findIndex(i => i.stockCode == newSubscription.stockCode);

      let currentQty = parseInt(this.newOrderItems[index].qty);
      this.newOrderItems[index].qty = (parseInt(quantity) + currentQty).toString();
      this.newOrderItems[index].totalPrice = (parseInt(this.newOrderItems[index].qty) * parseFloat(this.newOrderItems[index].price.replace('$', '').replace(/,/g, ''))).toString();

    }
    this.loadContent = true;
    this.commonService.implementToast('New Item added', 'Success');
    this.calculatePendingTotal();

    this.setDisabled = false;

  }

  getTotalPrice(price: string, quantity: string): string {

    if (quantity !== '' && quantity !== '0')
      return (parseFloat(price.replace('$', '').replace(/,/g, '')) * parseInt(quantity)).toString();
    return '0';
  }

  calculatePendingTotal(): void {
    let total = 0;
    let count = 0;

    this.sortedSubscriptions.filter(s => s.out_status === 'B' || s.out_status === '')
      .forEach(s => {
        total += parseFloat(s.out_amount);

        if (s.itemChanged)
          count++;
      });
    this.newOrderItems.forEach(i => total += parseFloat(i.totalPrice));
    this.pendingTotal = total;

    if (count === 0 && this.newOrderItems.length === 0) {
      this.pendingTotal = 0;
      this.confirmRequired = false;
    } else {
      this.confirmRequired = true;
    }

    this.varianceAmount = this.pendingTotal - this.activeTotal;
  }

  finishAddSubscriotions(): void {
    if (this.programType === 'ADM') {
      this.manageService.monitorADKPendingSubscriptions(this.newOrderItems);
    }
    if (this.programType === 'ADY') {
      this.manageService.monitorADKADYPendingSubscriptions(this.newOrderItems);
    }
    this.router.navigateByUrl('/manageSubscriptions/manageAnnuities/' + this.programType +'/ADKDetails/' + this.tenantId);
  }

  close() {
    if (this.programType === 'ADM') {
      this.manageService.monitorADKPendingSubscriptions(this.newOrderItems);
    }
    if (this.programType === 'ADY') {
      this.manageService.monitorADKADYPendingSubscriptions(this.newOrderItems);
    }
    this.router.navigateByUrl('/manageSubscriptions/manageAnnuities/' + this.programType +'/ADKDetails/' + this.tenantId);
    $('#levelOne').animate({ scrollLeft: 250 }, 400);
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
